import { InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';

export interface AppConfig {
  appName: string;
  appDisplayName: string;
  isProduction: boolean;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('AppConfig');

export const appConfig: AppConfig = {
  appName: 'bpweb',
  appDisplayName: 'BpWeb',
  isProduction: environment.production
};
